/**
 * Client config runtime loader.
 * Reads EXPO_PUBLIC_CLIENT env var, imports the client config,
 * validates against schema, caches as singleton.
 */
import { env } from '../env'
import { ClientConfigSchema, type ClientConfig } from './config.schema'

// Import all client configs statically (Metro can't do dynamic imports)
// New clients: add their import here
import tagoConfig from '../../clients/tago/client.config'

const CLIENT_REGISTRY: Record<string, ClientConfig> = {
  tago: tagoConfig,
}

let cached: ClientConfig | null = null

export function getClientConfig(): ClientConfig {
  if (cached) return cached

  const clientId = env.EXPO_PUBLIC_CLIENT ?? 'tago'
  const raw = CLIENT_REGISTRY[clientId]

  if (!raw) {
    throw new Error(`Unknown client: "${clientId}". Register it in lib/client/config.ts`)
  }

  cached = ClientConfigSchema.parse(raw)
  return cached
}
